import { AuthFirebaseRestClient } from "./api/auth-firebase.client";
import { getUserProfile } from "./api/clients-user-profile.client";
import { FirebaseRestClient } from "./api/firebase.client";
import { recoverPassword } from "./api/login-bff.client";
import { OldAuthRestClient } from "./api/old-auth.client";
import { SkyTermsClient } from "./api/sky-terms.client";

// const SKY_LOGIN_BFF_URL = process?.env?.SKY_LOGIN_BFF_URL || 'https://sky-login-bff-qa.skyairline.com'
// const OLD_AUTH_API_URL = process?.env?.OLD_AUTH_API_URL || 'https://auth-qa.skyairline.com'
// const FIREBASE_API_KEY = process?.env?.FIREBASE_API_KEY || 'AIzaSyA3veej-DSMQ2Qo9y1CUAjzu7QWS3VwMUQ'
// const FIREBASE_AUTH_DOMAIN = process?.env?.FIREBASE_AUTH_DOMAIN || 'skyairline-s.firebaseapp.com'
// const FIREBASE_PROJECT_ID = process?.env?.FIREBASE_PROJECT_ID || 'skyairline-s'
// const FIREBASE_STORAGE_BUCKET = process?.env?.FIREBASE_STORAGE_BUCKET || 'skyairline-s.appspot.com'
// const FIREBASE_MESSAGING_SENDER_ID = process?.env?.FIREBASE_MESSAGING_SENDER_ID || '1066250637640'
// const FIREBASE_APP_ID = process?.env?.FIREBASE_APP_ID || '1:1066250637640:web:7b2587287c18dbac87a37d'
// const KOUNT_CLIENT_ID = process.env.KOUNT_CLIENT_ID

const SKY_LOGIN_BFF_URL = "https://sky-login-bff.skyairline.com";
const OLD_AUTH_API_URL = "https://auth.skyairline.com";
const FIREBASE_API_KEY = "AIzaSyAnXd9gDC4ph46Wo79UuaLd-3V1SRUCqAo";
const FIREBASE_AUTH_DOMAIN = "preprod-sky.firebaseapp.com";
const FIREBASE_PROJECT_ID = "preprod-sky";
const FIREBASE_STORAGE_BUCKET = "preprod-sky.appspot.com";
const FIREBASE_MESSAGING_SENDER_ID = "191669274648";
const FIREBASE_APP_ID = "1:191669274648:web:054c5fe2eeefb146c6db6d";
const SKY_TERMS_MS = "https://sky-terms-and-conditions.skyairline.com";
const LOYALTY_URL = "https://skyplus.skyairline.com/token";

new FirebaseRestClient(
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_PROJECT_ID,
  FIREBASE_STORAGE_BUCKET,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_APP_ID
).createClient();
const firebaseAuth = new AuthFirebaseRestClient(SKY_LOGIN_BFF_URL);
const skyTermsClient = new SkyTermsClient(SKY_TERMS_MS);

export const login = async (username: string, password: string) => {
  try {
    const oldAuth = new OldAuthRestClient(OLD_AUTH_API_URL);
    const response = await oldAuth.login(username, password);
    const { data } = response;
    if (data) {
      const res = await oldAuth.fetchUser(response.data.token);
      data.user = { ...res.data, surname: res.data.lastName };
    }
    return {
      ...data,
      isDigitalChannelUser: true,
    };
  } catch (error) {
    const response = await loginFirebase(username, password);
    return response;
  }
};

export const loginFirebase = async (username: string, password: string) => {
  try {
    const response = await firebaseAuth.login(username, password);
    const data = {
      firstName: response.user.firstName,
      mail: response.user.email,
      role: "DEFAULT",
      token: response.user.accessToken,
      loggedBy: "firebase",
      refreshToken: response._tokenResponse.refreshToken,
      props: [],
      emailVerified: response.user.emailVerified,
    };
    return data;
  } catch (error: any) {
    return { error };
  }
};

export const loginWithGoogle = async (homemarket: string) => {
  try {
    const response = await firebaseAuth.loginWithGoogle(homemarket);
    const userData = response.content.responseFirebase;
    const data = {
      name: `${userData.displayName || ""}`,
      mail: userData.email || "",
      firstName: userData.firstName,
      lastName: userData.lastName,
      role: "DEFAULT",
      token: response.content.responseFirebase.stsTokenManager.accessToken,
      refreshToken:
        response.content.responseFirebase.stsTokenManager.refreshToken,
      loggedBy: "firebase",
      props: [],
    };

    return data;
  } catch (error) {
    return { error };
  }
};

export const riskCheck = (sessionId: string, token: string): Promise<any> => {
  return firebaseAuth.client.post(
    "/risk-management/v1/risk-check",
    { sessionId },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// -> To Risk Status
export const riskStatus = (reg: string, sessionId: string): Promise<any> => {
  return firebaseAuth.client.post("/risk-management/v1/risk/status", {
    reg,
    sessionId,
  });
};

export const getTokenSky = async (token: string) => {
  try {
    return firebaseAuth.client.get("user/v1/users", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    return JSON.parse(JSON.stringify(error));
  }
};

// -> To Risk Attempt Failed
export const riskAttemptFailed = (
  email: string,
  sessionId: string
): Promise<any> => {
  return firebaseAuth.client.post("/risk-management/v1/attemp/login", {
    email,
    sessionId,
  });
};

export const restoreNewPassword = async (code: string, newPassword: string) => {
  try {
    const response = await firebaseAuth.restore(code, newPassword);
    return {
      success: true,
      response,
    };
  } catch (error: any) {
    return { error };
  }
};

export const verifyEmail = async (code: string) => {
  try {
    const response = await firebaseAuth.verify(code);
    return {
      success: true,
      response,
    };
  } catch (error: any) {
    return { error };
  }
};

export const getLastAcceptedTerms = async (userId: string) => {
  try {
    const response = await skyTermsClient.getLastAcceptedTerms(userId);
    return response.data;
  } catch (error: any) {
    return { error };
  }
};

export const getLastTermsAndConditions = async () => {
  try {
    const response = await skyTermsClient.getLastTermsAndConditions();
    return response.data;
  } catch (error: any) {
    return { error };
  }
};

export const callRefreshToken = async (token: string) => {
  try {
    const response = await firebaseAuth.refreshToken(token);
    return response.data;
  } catch (error: any) {
    return { error };
  }
};

export const redirecToSkyPlus = async (refreshToken: string) => {
  try {
    const {
      content: { token },
    } = await callRefreshToken(refreshToken);
    const skyToken = token;
    const formattedToken = skyToken.includes("Bearer")
      ? skyToken.replace("Bearer ", "")
      : skyToken;
    window.location.href = `${LOYALTY_URL}?jwt=${formattedToken}`;
  } catch (error: any) {
    return { error };
  }
};

export { recoverPassword, getUserProfile };
